import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {
    deleteUploads,
    getUploads,
    onClearUploads,
    sendPackageToRecognition,
    setDetailedFilePages,
    setDetailedUpload,
    setSelectedIds,
    setShowPreviewPages,
    setUploadIsLoading,
    setUploadPageCount,
    setUploadPopupOpen,
    setUploads,
    uploadFiles,
} from "../../ducks/upload";
import {State} from "../../store/rootReducers";
import {
    selectDetailedFilePages,
    selectIdsOfSelectedFile,
    selectShowPreviewPages,
    selectUploadDetailedFile,
    selectUploadFiles,
    selectUploadPopupIsOpen,
    selectUploadsIsLoading,
    selectUploadsPageCount
} from "../../selectors/upload";
import {popupPush} from "../../ducks/popup";
import {IUploadPopupDispatchProps, IUploadPopupStateProps, UploadPopup} from "./UploadPopup";

const mapStateToProps: MapStateToProps<IUploadPopupStateProps, {}, State> = state => {
    let props: IUploadPopupStateProps = {
        files: [],
        detailedFile: undefined,
        pageCount: 0,
        isLoading: true,
        page: undefined,
        selectedIds: [],
        showPreviewPages: true,
        isOpen: false,
    };

    const detailedFile = selectUploadDetailedFile(state);
    if (detailedFile) {
        props.detailedFile = {...detailedFile};
    }
    props.isLoading = selectUploadsIsLoading(state);
    props.files = selectUploadFiles(state);
    props.pageCount = selectUploadsPageCount(state);
    props.page = selectDetailedFilePages(state);
    props.selectedIds = selectIdsOfSelectedFile(state);
    props.showPreviewPages = selectShowPreviewPages(state);
    props.isOpen = selectUploadPopupIsOpen(state);
    return {...props}
};

const dispatchProps: MapDispatchToProps<IUploadPopupDispatchProps, {}> = {
    setUploads,
    uploadFiles,
    setSelectedIds,
    setDetailedUpload,
    setUploadIsLoading,
    setUploadPageCount,
    setDetailedFilePages,
    popupPush,
    setShowPreviewPages,
    setUploadPopupOpen,
    onClearUploads,
    sendPackageToRecognition,
    getUploads,
    deleteUploads,
};

export const UploadPopupConnected = connect(
    mapStateToProps,
    dispatchProps,
)(UploadPopup);
